import { detectOverflow, type State } from "@popperjs/core";

// https://popper.js.org/docs/v2/utils/detect-overflow/#return-value
// when popper is negative or 0 its inside of boundaries, positive is outside
const offsetOutsideViewport = 1;
export const isOffsetOutsideViewport = (state: State) => {
  const overflow = detectOverflow(state);
  return Math.sign(overflow.bottom) === offsetOutsideViewport || Math.sign(overflow.top) === offsetOutsideViewport;
};
